<template>
  <div>
    <v-card tile flat color="#502D7C" width="100%" height="140px" :class="$vuetify.breakpoint.mdAndUp ? '' : 'pb-10'">
      <v-container class="fill-height">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="4" md="1">
            <v-avatar size="60" class="rounded-un" color="#ffffff3A" v-if="$vuetify.breakpoint.mdAndUp">
              <v-icon large color="white">mdi-account-outline</v-icon>
            </v-avatar>
            <div v-if="!$vuetify.breakpoint.mdAndUp">
              <img @click="check()" :src="require('@/assets/arrow-left@1,5x.svg')" width="16px" class="mr-2 fake-link" />
            </div>
          </v-col>
          <v-col cols="4" md="3" class="px-0 text-md-left text-center">
            <span class="profile-title font-dm color-white">Meu Perfil</span>
          </v-col>
          <v-col cols="4" md="4" class="category-text font-dm color-white"> </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-container :class="$vuetify.breakpoint.mdAndUp ? 'my-5' : ''" style="position: relative">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.mdAndUp" md="4">
          <TheSideBar />
        </v-col>

        <v-col cols="12" md="6">
          <v-row align="center" justify="center" class="mb-3" v-if="$vuetify.breakpoint.mdAndUp">
            <v-col>
              <v-btn dark color="#7D4CA8" :loading="loading" class="rounded-un" block depressed @click="preLoadFile()">
                Alterar Imagem
                <v-icon dark class="ml-2">mdi-camera</v-icon>
              </v-btn>

              <v-progress-linear stream height="5" :loading="loading" class="mt-1" :value="upload" color="#7D4CA8" v-if="uploading"></v-progress-linear>
            </v-col>
          </v-row>

          <div v-if="!$vuetify.breakpoint.mdAndUp" class="mb-5">
            <v-card class="pa-6 rounded-un shaddow-un mb-5 backcard">
              <TheUserHeader />
            </v-card>
            <v-btn dark color="#7D4CA8" class="rounded-un" :loading="loading" block depressed x-large @click="$refs.file.click()">
              Alterar Imagem
              <v-icon dark class="ml-2">mdi-camera</v-icon>
            </v-btn>
            <v-progress-linear stream height="5" class="mt-1" :value="upload" color="#7D4CA8" v-if="uploading"></v-progress-linear>
          </div>

          <input type="file" ref="file" style="display: none" accept="image/*" @change="previewFile()" />

          <v-form ref="formValid" v-model="valid" lazy-validation>
            <div v-if="montado">
              <div v-for="(item, i) in fields" :key="i" class="mb-0">
                <span class="profile-text-field font-dm">{{ item.title }}</span>
                <v-text-field
                  filled
                  dense
                  outlined
                  background-color="#ffffff"
                  class="mt-2 input-un"
                  :type="item.text"
                  :placeholder="item.placeholder"
                  v-if="item.type === 'text' && item.rules"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  :rules="item.rules"
                  @change="needSalve()"
                ></v-text-field>

                <v-text-field
                  filled
                  dense
                  outlined
                  background-color="#ffffff"
                  class="mt-2 input-un"
                  :type="item.text"
                  :placeholder="item.placeholder"
                  v-if="item.type === 'text' && !item.rules"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  @change="needSalve()"
                ></v-text-field>

                <v-text-field
                  filled
                  dense
                  outlined
                  background-color="white"
                  class="mt-2 input-un"
                  :placeholder="item.placeholder"
                  v-if="item.type === 'phone'"
                  v-mask="'(##) #####-####'"
                  type="tel"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  @change="needSalve()"
                ></v-text-field>

                <v-text-field
                  filled
                  dense
                  outlined
                  background-color="white"
                  class="mt-2 input-un"
                  :placeholder="item.placeholder"
                  v-if="item.type === 'date'"
                  v-mask="'##/##/####'"
                  type="tel"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  :rules="item.rules"
                  @change="ignoreRule(item)"
                ></v-text-field>

                <v-text-field
                  filled
                  dense
                  outlined
                  background-color="white"
                  class="mt-2 input-un"
                  :placeholder="item.placeholder"
                  v-if="item.type === 'cep'"
                  v-mask="'#####-###'"
                  type="tel"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  :rules="item.rules"
                ></v-text-field>

                <v-select
                  filled
                  dense
                  outlined
                  background-color="#ffffff"
                  class="my-2 input-un"
                  v-if="item.type === 'select' && item.name === 'schooling'"
                  :items="filterSchool(item.values)"
                  item-text="titulo"
                  item-value="id"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  @change="needSalve()"
                  placeholder="Selecione"
                ></v-select>

                <v-select
                  filled
                  dense
                  outlined
                  background-color="#ffffff"
                  class="my-2 input-un"
                  v-if="item.type === 'select' && item.name !== 'schooling'"
                  :items="item.values"
                  item-text="titulo"
                  item-value="id"
                  color="#502d7c"
                  v-model="userNew[item.name]"
                  @change="needSalve()"
                  placeholder="Selecione"
                ></v-select>
              </div>
            </div>
          </v-form>

          <v-btn dark color="#7D4CA8" class="rounded-un" block depressed :loading="loading" @click="checkRegister()">
            <v-icon dark class="mr-2">mdi-content-save-outline</v-icon>
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="popup" max-width="600px" overlay-color="white">
      <template>
        <v-card class="rounded-un pa-5 text-center color-purple">
          <div class="text-right">
            <v-icon small color="#502d7c" @click="popup = false">mdi-close</v-icon>
          </div>
          <b>
            <p class="color-purple font-dm">Sua escolaridade define sua jornada aqui na plataforma. Você escolheu {{ getSchooling() }}, está ok?</p>
          </b>
          <v-row>
            <v-col>
              <v-btn dark color="#7D4CA8" class="rounded-un" block outlined depressed x-large @click="popup = false">
                Não
              </v-btn>
            </v-col>
            <v-col>
              <v-btn dark color="#7D4CA8" class="rounded-un" block depressed x-large @click="register()">
                Sim
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'
import TheUserHeader from '@/components/TheUserHeader'
import TheSideBar from '@/components/TheSideBar'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'

export default {
  directives: { mask },
  components: {
    TheUserHeader,
    TheSideBar,
  },
  data: () => ({
    valid: false,
    loading: false,
    popup: false,
    needToSave: false,
    uploading: false,
    upload: 0,
    fields: [
      {
        name: 'name',
        title: 'Nome',
        type: 'text',
        placeholder: 'Nome',
        rules: [(v) => !!v || 'O nome é necessário'],
      },
      {
        name: 'email',
        title: 'E-mail',
        type: 'text',
        placeholder: 'Email',
        rules: [(v) => !!v || 'E-mail é necessário', (v) => /.+@.+\..+/.test(v) || 'É preciso um e-mail válido'],
      },
      {
        name: 'schooling',
        title: 'Escolaridade',
        placeholder: '',
        type: 'select',
        values: [],
      },
      {
        name: 'birthday',
        title: 'Data de Nascimento',
        placeholder: 'Data',
        type: 'date',
        rules: [(v) => !v || (v && v.length === 0) || (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/.test(v)) || 'Data Inválida'],
      },
      {
        name: 'phone',
        title: 'Fone',
        type: 'phone',
        placeholder: '(55) 9 9999-9999',
      },
      {
        name: 'cep',
        title: 'CEP',
        placeholder: '#####-###',
        type: 'cep',
        rules: [(v) => !v || (v && v.length === 0) || (v && v.length === 9) || 'O CEP é Inválido'],
      },
      {
        name: 'endereco',
        title: 'Endereço',
        placeholder: 'Escreva',
        type: 'text',
      },
      {
        name: 'numero',
        title: 'Número',
        placeholder: 'Número',
        type: 'text',
      },
      {
        name: 'bairro',
        title: 'Bairro',
        placeholder: 'Escreva',
        type: 'text',
      },
      {
        name: 'complemento',
        title: 'Complemento',
        placeholder: 'Escreva',
        type: 'text',
      },
      {
        name: 'cidade',
        title: 'Cidade',
        placeholder: 'Escreva',
        type: 'text',
      },
      {
        name: 'estado',
        title: 'Estado',
        placeholder: 'Selecione',
        type: 'select',
        values: [
          { titulo: 'Acre', id: 'AC' },
          { titulo: 'Alagoas', id: 'AL' },
          { titulo: 'Amapá', id: 'AP' },
          { titulo: 'Amazonas', id: 'AM' },
          { titulo: 'Bahia', id: 'BA' },
          { titulo: 'Ceará', id: 'CE' },
          { titulo: 'Distrito Federal', id: 'DF' },
          { titulo: 'Espírito Santo', id: 'ES' },
          { titulo: 'Goiás', id: 'GO' },
          { titulo: 'Maranhão', id: 'MA' },
          { titulo: 'Mato Grosso', id: 'MT' },
          { titulo: 'Mato Grosso do Sul', id: 'MS' },
          { titulo: 'Minas Gerais', id: 'MG' },
          { titulo: 'Pará', id: 'PA' },
          { titulo: 'Paraíba', id: 'PB' },
          { titulo: 'Paraná', id: 'PR' },
          { titulo: 'Pernambuco', id: 'PE' },
          { titulo: 'Piauí', id: 'PI' },
          { titulo: 'Rio de Janeiro', id: 'RJ' },
          { titulo: 'Rio Grande do Norte', id: 'RN' },
          { titulo: 'Rio Grande do Sul', id: 'RS' },
          { titulo: 'Rondônia', id: 'RO' },
          { titulo: 'Roraima', id: 'RR' },
          { titulo: 'Santa Catarina', id: 'SC' },
          { titulo: 'São Paulo', id: 'SP' },
          { titulo: 'Sergipe', id: 'SE' },
          { titulo: 'Tocantins', id: 'TO' },
        ],
      },
    ],
    userNew: {},
    montado: false,
    schools: [],
    value: '',
    picture: null,
    changeSchooling: false,
    theReset: false,
    salvoText: false,
  }),
  computed: {
    ...mapState(['user', 'journey', 'save', 'option', 'logged', 'logoff']),
    getClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'pa-6 rounded-un shaddow-un'
      } else {
        return 'pa-6 rounded-un shaddow-un mt-n15'
      }
    },
  },
  watch: {
    save() {
      if (this.save === true) {
        this.salvar()
      }
    },
    option() {
      if (!this.logoff) {
        if (this.option === 0 && !this.changeSchooling && !this.theReset) {
          this.salvar()
          this.$store.dispatch('setOptionInfo', null)
        }
        if (this.changeSchooling) {
          if (this.option === 1) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Beleza, então vamos manter sua escolaridade atual! Mas você pode voltar aqui e editá-la a qualquer momento.',
              route: '/jornada',
            })
            localStorage.removeItem('salveProfile')
            this.$store.dispatch('setOptionInfo', null)
            this.changeSchooling = false
            this.theReset = false
            this.salvoText = false
          }
          if (this.option === 0) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Beleza! Agora você terá acesso a uma nova jornada cheia de novidades. Você terá acesso a novos conteúdos e experiências. Vem com a gente!',
              button: [{ text: 'Vamos Lá' }],
            })
            this.$store.dispatch('setOptionInfo', null)
            this.userNew.reset_journey = 'full'
            this.userNew.email = this.user.email
            this.changeSchooling = false
            this.theReset = true
          }
        }
        if (this.theReset === true) {
          if (this.option === 0) {
            localStorage.removeItem('resetJourney')
            localStorage.removeItem('TheEnd')
            this.$store.dispatch('setReset2Info', true)
            this.$store.dispatch('setOptionInfo', null)
            this.theReset = false
            this.salvar()
            window.location = '/conectameufuturo/'
          }
        }
      }
    },
  },
  methods: {
    goBack() {
      window.history.back()
    },
    check() {
      const profile = localStorage.getItem('salveProfile')
      if (profile) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Deseja salvar as alterações?',
          button: [{ text: 'Salvar' }, { text: 'Cancelar', outlined: true }],
        })
      } else {
        window.history.back()
      }
    },
    previewFile() {
      if (this.$refs.file.files[0]) {
        if (this.$refs.file.files[0].size > 1048576) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Ops, tamanho de imagem muito grande. A imagem pode ter até 1Mb de tamanho!',
          })
          return false
        }

        this.uploading = true
        const file = this.$refs.file.files[0]
        const reader = new FileReader()

        reader.onloadend = () => {
          this.changePicture(reader.result)
          this.uploading = false
        }

        reader.onprogress = (data) => {
          if (data.lengthComputable) {
            var progress = parseInt((data.loaded / data.total) * 100, 10)
            this.upload = progress
          }
        }

        if (file) {
          reader.readAsDataURL(file)
        } else {
          if (this.user.avatar) {
            this.picture = this.user.avatar
          }
        }
      }
    },
    changePicture(pic) {
      this.picture = pic
      const user = { avatar: pic }
      this.loading = true
      const qs = require('qs')
      const url = `${baseApiUrl}/saveUserData`
      const object = qs.stringify(user)

      axios
        .post(url, object)
        .then((res) => {
          localStorage.setItem('user', JSON.stringify(res.data))
          this.$store.dispatch('setUserInfo', {
            user: res.data,
          })
          this.loading = false
        })
        .catch(() => {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
          })
        })
    },
    preLoadFile() {
      this.$refs.file.click()
    },
    salvar() {
      if (!this.userNew.reset_journey) {
        this.$refs.formValid.validate()
      }

      if (this.uploading && this.userNew.reset_journey !== 'full') {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Ops! Sua foto ainda está carregando!',
        })
        return false
      }

      if (!this.valid && this.userNew.reset_journey !== 'full') {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Ops, temos algum probleminha. Cheque os campos pra ver se tudo foi preenchido corretamente.',
        })
        return
      }

      this.loading = true
      const qs = require('qs')
      const url = `${baseApiUrl}/saveUserData`

      let oldBirth = this.userNew.birthday
      if (this.userNew.birthday) {
        const newBirth = this.userNew.birthday.split('/')
        this.userNew.birthday = newBirth[2] + '-' + newBirth[1] + '-' + newBirth[0]
      }
      const object = qs.stringify(this.userNew)
      this.userNew.birthday = oldBirth

      axios
        .post(url, object)
        .then((res) => {
          this.loading = false
          this.tratarRes(res.data)
        })
        .catch(() => {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
          })
        })
    },
    saveImage() {},
    register() {
      this.popup = false
      if (this.userNew.schooling !== this.user.schooling) {
        if (this.needChangeJourney()) {
          this.changeSchooling = true
          const url = `${baseApiUrl}/journey`
          axios.post(url).then((res) => {
            let ret = false
            Object.keys(res.data.posts).forEach((key) => {
              const element = res.data.posts[key]
              if (this.checkBonus(element)) {
                ret = true
              }
            })

            if (ret === true) {
              this.salvoText = true
              this.$store.dispatch('setErrorInfo', {
                open: true,
                text:
                  '🎉 PARABÉNS! Você avançou na sua jornada, ficamos muito contentes com isso! Agora, você tem acesso a NOVOS conteúdos, recompensas e muito mais. MAS ATENÇÃO! Primeiro você precisa resgatar seus bônus e recompensas da jornada anterior.',
                button: [{ text: 'Já resgatei' }, { text: 'Resgatar Primeiro ', outlined: true }],
              })
            } else {
              this.userNew.reset_journey = 'full'
              this.userNew.email = this.user.email
              this.salvoText = true
              this.salvar()
              this.$store.dispatch('setErrorInfo', {
                open: true,
                text: 'PARABÉNS! Você avançou na sua jornada, ficamos muito contentes com isso! Agora, você tem acesso a NOVOS conteúdos, recompensas e muito mais.',
                button: [{ text: 'Continuar ' }],
              })
            }
          })
        } else {
          this.salvoText = true
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: '🎉 Você trocou de escolaridade! Continue interagindo com os nossos conteúdos para avançar na sua jornada.',
          })
          this.salvar()
        }
      } else {
        this.salvar()
      }
    },
    checkBonus(el) {
      if (el.conclusionsTotal) {
        return true
      }
      if (el.bonusTotal) {
        return true
      }
      return false
    },
    loadImage() {
      if (this.$refs.file.files[0]) {
        const file = this.$refs.file.files[0]
        var reader = new FileReader()

        reader.onloadend = () => {
          this.userNew.avatar = reader.result
          this.uploading = false
          this.salvar()
        }
        if (file) {
          reader.readAsDataURL(file)
        }
      }
    },
    tratarRes(res) {
      if (!res.success) {
        return false
      }
      localStorage.removeItem('salveProfile')
      localStorage.setItem('user', JSON.stringify(res))

      this.$store.dispatch('setUserInfo', {
        user: res,
      })

      if (this.userNew.reset_journey !== 'full' && !this.theReset && !this.changeSchooling && !this.salvoText) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Salvo',
        })
        this.salvoText = false
        this.theReset = false
        this.changeSchooling = false
      }
    },
    loadSchools() {
      const url = `${baseApiUrl}/school_levels`
      axios
        .get(url)
        .then((res) => {
          this.schools = res.data
          for (let i = 0; i < this.fields.length; i++) {
            const element = this.fields[i]
            if (element.name === 'schooling') {
              this.fields[i].values = res.data
            }
          }
        })
        .catch(() => {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
          })
        })
    },
    checkRegister() {
      if (this.user.schooling !== this.userNew.schooling) {
        this.popup = true
      } else {
        this.register()
      }
    },
    getSchooling() {
      if (!this.userNew.schooling) {
        return false
      }
      for (let i = 0; i < this.schools.length; i++) {
        const element = this.schools[i]
        if (element.id === this.userNew.schooling) {
          return element.titulo
        }
      }
      return ''
    },
    filterSchool(array) {
      if (!this.user.schooling) {
        return array
      } else {
        let add = 0
        for (let i = 0; i < array.length; i++) {
          const element = array[i]
          if (this.user.schooling === element.id) {
            add = parseInt(element.school_level)
          }
        }
        const filtered = []
        for (let i = 0; i < array.length; i++) {
          const element = array[i]
          if (element.school_level >= add) {
            filtered.push(element)
          }
        }
        return filtered
      }
    },
    needSalve() {
      if (this.montado) {
        localStorage.setItem('salveProfile', true)
      }
    },
    ignoreRule(item) {
      if (this.userNew[item.name] === '' || !this.userNew[item.name]) {
        item.rules = []
      } else {
        item.rules = [(v) => /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/.test(v) || 'Data Inválida']
      }
    },
    needChangeJourney() {
      let newSchoolLvl = 0
      let oldSchoolLvl = 0
      const array = this.schools
      for (let i = 0; i < array.length; i++) {
        const element = array[i]
        if (this.userNew.schooling === element.id) {
          newSchoolLvl = parseInt(element.school_level)
        }
        if (this.user.schooling === element.id) {
          oldSchoolLvl = parseInt(element.school_level)
        }
      }
      if (newSchoolLvl !== oldSchoolLvl) {
        return true
      } else {
        return false
      }
    },
    loadContent() {
      const url = `${baseApiUrl}/getUserData`
      axios
        .get(url)
        .then((res) => {
          this.$store.dispatch('setUserInfo', {
            user: res.data,
          })

          Object.keys(this.user).forEach((key) => {
            if (key === 'birthday' && this.user[key]) {
              const newBirth = this.user[key].split('-')
              this.userNew[key] = newBirth[2] + '/' + newBirth[1] + '/' + newBirth[0]
            } else {
              this.userNew[key] = this.user[key]
            }
          })
        })
        .catch(() => {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
          })
        })
    },
  },
  mounted() {
    this.loadContent()
    this.$store.dispatch('setMobileRouterInfo', '/perfil')

    this.picture = this.user.avatar
    this.montado = true
    this.loadSchools()
  },
  created() {
    window.scrollTo(0, 0)
    if (!this.logged) {
      this.$router.push('/login')
    }
  },
}
</script>

<style>
.profile-text-field {
  display: block;
  color: #502d7c;
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 18px !important;
}
</style>
